import { useState, useEffect } from 'react'

const isBrowser = typeof window !== 'undefined'

const useDisplayScroll = () => {
  const [displayScrollTo, setDisplayScrollTo] = useState(
    isBrowser ? window.pageYOffset > 100 : false
  )

  const listener = () => {
    setDisplayScrollTo(window.pageYOffset > 100)
  }

  useEffect(() => {
    window.addEventListener('scroll', listener)
    return () => {
      window.removeEventListener('scroll', listener)
    }
  })

  if (!isBrowser) {
    return false
  }

  return displayScrollTo
}

export default useDisplayScroll
